module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/line-e84dbc308ccfae2f326b78838f1d78f8.svg&quot;;"